export const ValidationTypes = {
  BIN: 'BIN',
  NONE: 'NONE',
  UNI_PAL: 'UNIPAL',
  CARD: 'CARD',
};
export const BANK_OFFER = 'BANK';
export const STATIC_OFFER = 'STATIC';
export const GENERAL_OFFER = 'GENERAL';
